var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoomService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell-concierge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.76318 4.0625C8.35189 4.0625 8.021 4.39339 8.021 4.80469C8.021 5.21598 8.35189 5.54688 8.76318 5.54688H9.25798V6.57666C5.78206 6.94466 3.07308 9.88867 3.07308 13.4635H4.55745C4.55745 10.4577 6.9943 8.02083 10.0002 8.02083C13.006 8.02083 15.4429 10.4577 15.4429 13.4635H16.9272C16.9272 9.88867 14.2183 6.94466 10.7423 6.57666V5.54688H11.2371C11.6484 5.54688 11.9793 5.21598 11.9793 4.80469C11.9793 4.39339 11.6484 4.0625 11.2371 4.0625H10.0002H8.76318ZM2.82568 14.4531C2.41439 14.4531 2.0835 14.784 2.0835 15.1953C2.0835 15.6066 2.41439 15.9375 2.82568 15.9375H17.1746C17.5859 15.9375 17.9168 15.6066 17.9168 15.1953C17.9168 14.784 17.5859 14.4531 17.1746 14.4531H2.82568Z",
    fill: "#334155"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomService);
export default __webpack_public_path__ + "static/media/room-service.d8eeec249e7eeae484c1d1d7721632e5.svg";
export { ForwardRef as ReactComponent };